import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HTTP_INTERCEPTORS,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { ToastService } from 'src/app/core/toast/toast.service';
import { ApiError, ApiErrorType } from 'src/app/model/global-interface';
import { environment } from 'src/environments/environment';
import { LocalStorageService } from '../local-storage.service';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  
  private errorTypeMap: Record<number, ApiErrorType> = {
    400: ApiErrorType.BadRequest,
    401: ApiErrorType.Unauthorized,
    403: ApiErrorType.Forbidden,
    404: ApiErrorType.NotFound,
    409: ApiErrorType.Conflict,
    422: ApiErrorType.Unprocessable,
  };

  constructor(
    private toast: ToastService,
    private localStorage: LocalStorageService // o AuthService.getToken()
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler)
    : Observable<HttpEvent<unknown>> {

    // --- 1) Aggiungo l'header Authorization se presente il token ---
    const session = this.localStorage.getTokens() || null;
    const token = session?.accessToken ?? '';

    // Solo per le chiamate al tuo API (opzionale, rimuovi il controllo se vuoi sempre allegarlo)
    const apiBase = environment.apiUrl; // importa environment se non già presente
    const isApiCall = request.url.startsWith(apiBase) || request.url.startsWith(`/${apiBase}`);

    if (token && isApiCall && !request.url.includes('refresh-token')) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    // --- 2) Gestione della risposta con catchError ---
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        const apiError = this.mapHttpErrorToApiError(error);
        this.toast.handleApiError(apiError);
        return throwError(() => apiError);
      })
    );
  }

  private mapHttpErrorToApiError(error: HttpErrorResponse): ApiError {
    const errorType = this.errorTypeMap[error.status] ?? ApiErrorType.InternalServer;
    console.log(errorType)

    return {
      type:       errorType,
      message:    error.error?.message || error.message || 'Errore sconosciuto',
      details:    error.error,
      statusCode: error.status
    };
  }
}

export const ApiInterceptorProvider = {
  provide:  HTTP_INTERCEPTORS,
  useClass: ApiInterceptor,
  multi:    true
};
